import axios from "axios";
import { redirectToLoginPage } from "@/utils/redirectToLoginPage";

const unauthorizedCode = [401];

const BaseService = axios.create({
  timeout: 60000,
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true, // クッキーを送信するために必要
});

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    if (response && unauthorizedCode.includes(response.status)) {
      console.error("Unauthorized request");
      // ログインページにリダイレクト
      // TODO: 401が返ってこないので後で確認
      redirectToLoginPage();
    }

    // TODO: 他のAPIエラー処理を追加する

    return Promise.reject(error);
  },
);

export default BaseService;
